import type { FaireProductEntity } from "../../entity_types/product";

export const p_4q9n6lrs63: FaireProductEntity = {
  token: "p_4q9n6lrs63",
  type: "product",
  name: "16oz Raw Wildflower Honey",
  brandToken: "b_2hhbtdht4d",
  brandName: "The Beekeeper's Daughter",
  imageUrl:
    "https://cdn.faire.com/fastly/75afb383a6c2f2e0ef494c2ced8aec5dad82623bf8ac017c048b3fb0b4f1bafc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e76b16510924461cd5bd00cce0c250eb74ac137fde26e4cbdd6f656bed8e59ee.jpeg",
    "https://cdn.faire.com/fastly/81ae306da748ec9e2ba263e05a22ab48896720d088d53cf0038a4c36605c54c9.jpeg",
    "https://cdn.faire.com/fastly/0b8beb848c337da3e77b915cddb83fc6757b86db1fe03ad256360101d171b195.jpeg",
    "https://cdn.faire.com/fastly/3e67bece172fffd6e74974ae04b95e59588a84203d1af84cc9a7b03914d20a37.jpeg",
  ],
  priceDollars: 10.74,
  description:
    "Our Raw Wildflower Honey comes from our Summer Honey crop. It's light in color and has a strong biting flavor with a distinctive lingering finish. Its somewhat fresh, pleasant \"woody\" scent pairs well with teas, camembert, and fresh goat cheeses. It's also great for seasonal allergies and is one of our household favorites!.                                                         \nThe Beekeeper's Daughter raw honey is full of pollen, enzymes, vitamins, minerals, and aroma. It can contain bits of pollen and propolis. Right from the hive to your table.\nSize: 1lb. (16oz).                                                                                                                           ",
  tags: [],
  msrpDollars: 20.77,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:55.556Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
